export const FLASH_TIMER = 100;
export const FAST_TIMER = 300;
export const TIMER = 500;
export const SLOW_TIMER = 1000;